module.exports = __webpack_public_path__ + "img/illustration_ramen.75de7a6e.png";